export default __webpack_public_path__ + "static/media/Dwelo-FCC-Label-3.3c852611.png";